import React, { CSSProperties } from "react";
import { Box } from "@mui/material";

type Props = {
    maxHeight: CSSProperties["maxHeight"];
    maxWidth: CSSProperties["maxWidth"];
    src: string;
};

const ImageHolder: React.FC<Props> = (props: Props) => {
    return (
        <Box
            maxHeight={props.maxHeight}
            maxWidth={props.maxWidth}
            width="100%"
            height={props.maxHeight}
            data-testid="logo-wrapper"
        >
            <Box
                height="100%"
                sx={{
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url(${props.src})`
                }}
            ></Box>
        </Box>
    );
};

export default ImageHolder;
